var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgH1Notification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71 23v4h-9v1a3 3 0 01-3.56 3A3.09 3.09 0 0156 27.83V27h-9v-4a3.61 3.61 0 003.07-2 9.6 9.6 0 00.86-4v-.88A8 8 0 0157 8V5a1.919 1.919 0 012.5-1.83A2.23 2.23 0 0161 5.31V8a8.17 8.17 0 016.11 8.06c0 7.66 3.89 6.65 3.89 6.94zm-9 13.21V52H30.33L18 62.12V52h-8V20h31.55a4 4 0 013-2 7.36 7.36 0 00.33-2H6v40h8v14.56L31.75 56H66V33h-.87A7 7 0 0162 36.21zM41 26H16v4h25v-4zM16 46h24.88v-4H16v4zm0-12v4h11.88v-4H16z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/H1_Notification.6306b2cf.svg";
export { SvgH1Notification as ReactComponent };